import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VUSeal from './VUSeal'
import { supabase } from '../supabaseClient'
import './AuthPage.css'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: 'https://university.vacatia.com/update-password',
      })
      if (error) throw error
      setSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-seal"><VUSeal size={120} /></div>
        {sent ? (
          <>
            <h1 className="auth-title">Check your email</h1>
            <p className="auth-sub">We sent a password reset link to {email}. Check your inbox and follow the link to reset your password.</p>
            <button className="auth-submit" style={{marginTop:'16px'}} onClick={() => navigate('/login')}>Back to sign in</button>
          </>
        ) : (
          <>
            <h1 className="auth-title">Reset your password</h1>
            <p className="auth-sub">Enter your email address and we will send you a link to reset your password.</p>
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <label className="auth-lbl">Email address</label>
                <input className="auth-input" type="email" placeholder="name@vacatia.com" value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              {error && <p className="auth-error">{error}</p>}
              <button className="auth-submit" type="submit" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
            </form>
            <p className="auth-switch">Remember your password? <span onClick={() => navigate('/login')} className="auth-link">Sign in</span></p>
          </>
        )}
      </div>
    </div>
  )
}
